/*jshint esversion: 6 */
import React, { useState } from 'react';
import axios from "axios";
import {url_api_skill_programming} from "../ApiUrls";


function HumanCreateSkillProgrammingModal(props){
    "use strict";

    const [newSkillProgramming, setNewSkillProgramming] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [newGoodAdd, setNewGoodAdd] = useState(false);
    const [newError, setNewError] = useState(null);

    function createNewElementGood(response){
        if (response.status === 201) {
            setNewGoodAdd(true);
            props.update('skill_programming');
        } else{
            setNewGoodAdd(false);
        }
    }

    const submitAddNewSkillProgramming = e => {
        setNewGoodAdd(false);
        axios({
            method: "POST",
            url: url_api_skill_programming,
            responseType: 'json',
            contentType: 'application/json',
            data: {
                title: newSkillProgramming,
                description: newDescription,
            }
            })
            .then(response => {
                setNewError(null);
                setNewSkillProgramming("");
                setNewDescription("");
                createNewElementGood(response);
            })
            .catch(function (error) {
                setNewError(error);
            });
    };

    function clear_messages(){
        setNewError(null);
        setNewGoodAdd(false);
    }

    function ModalHeader(){
        return (
            <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                onClick={clear_messages}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        )
    };

    function ModalFooter(){
        return (
            <div>
                <div className="modal-footer">
                    <input type="button" className="button button_blue" form="skill_add"
                           value="Add" onClick={submitAddNewSkillProgramming} />
                    <button type="button" className="button button_white" data-dismiss="modal"
                    onClick={clear_messages} >Close
                    </button>
                </div>
                {newError
                    ? newError.response.data.title ? newError.response.data.title[0] : ""
                : ""}
                {newGoodAdd?"Element Add!!":""}
            </div>
        )
    };

    return (
        <div className="modal fade" id="Modal_skill" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel3"
             aria-hidden="true">
        {/*<!-----------------------------------Modal Skill Programming-------------------->*/}
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    {ModalHeader()}
                    <div className="modal-body">
                        <h2 className="modal-title" id="myModalLabel3">Add new skill</h2>
                        <form id="skill_add">
                            <input className="profile__input" type="text" placeholder="Input skill" name="name"
                                   form="skill_add"
                                   value={newSkillProgramming?newSkillProgramming:''}
                                   onChange={t => setNewSkillProgramming(t.target.value)}/>
                        </form>
                    </div>
                    {ModalFooter()}
                </div>
            </div>
        </div>
    )
}

export default HumanCreateSkillProgrammingModal;

